module.exports = __webpack_public_path__ + "img/2.1ac8ea7e.png";